/*
 * This file is part of react-svg-buttons.
 *
 * (c) Raphaël Benitte
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import arrowDown   from './arrow-down'
import arrowLeft   from './arrow-left'
import arrowRight  from './arrow-right'
import arrowUp     from './arrow-up'
import ban         from './ban'
import bars        from './bars'
import check       from './check'
import cross       from './cross'
import crossSparks from './cross-sparks'
import code        from './code'
import ffwd        from './ffwd'
import fwd         from './fwd'
import hashtag     from './hashtag'
import home        from './home'
import inbox       from './inbox'
import plus        from './plus'
import plusSparks  from './plus-sparks'
import thunderbolt from './thunderbolt'


export default {
    arrowDown,
    arrowLeft,
    arrowRight,
    arrowUp,
    ban,
    bars,
    check,
    cross,
    crossSparks,
    code,
    ffwd,
    fwd,
    hashtag,
    home,
    inbox,
    plus,
    plusSparks,
    thunderbolt,
}



/** WEBPACK FOOTER **
 ** src/icon-types/index.js
 **/